module.exports = __webpack_public_path__ + "static/tom.8773dd12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/profile/tom.jpg
// module id = 137
// module chunks = 145532727447631 222457311475995